import { GetUserItemFacetsArgs } from 'types/api/arguments/get-user-item-facets-args'
import { ItemFacetsResp } from 'types/api/response/item-facets-resp'

import { api } from './api'

export const getUserItemFacets = ({ userId }: GetUserItemFacetsArgs) =>
  api.get<ItemFacetsResp>(`/users/${userId}/item_facets`)
